// extracted by mini-css-extract-plugin
module.exports =  {"loadingTextWrapper":"loadingTextWrapper_H_ntXB9e","loadingText":"loadingText_LMun7b0x","errorWrapper":"errorWrapper_b77BM475","error":"error_B3nQEoIi"};